import ProjectItem from "./ProjectItem";
import Project from "./Project";
import Person from "./Person";
import AodObject from "./AodObject";
import {map, mapValues, isArray} from "lodash";
import SpecAd from "./SpecAd";


const defaultTypes = [
    'Account',  // Simple AOD object
    'Advertiser',
    'SalesSheet',
    'Company',
    'History',
    'Order',
    'Publication'
];


export default function AodObjectFactory(aodService)
{
    this.aodService = aodService;
    this.objects = {  // custom logic
        SpecAd,
        Person,
        Project,
        ProjectItem
    };

    defaultTypes.forEach( type=> {
        // todo Will this set  instance names? as the function isn't named
        this.objects[type] = function (record) {
            AodObject.call(this, record, aodService, type);
        };

        this.objects[type].prototype = Object.create(
            AodObject.prototype,
            {}
        );

        this.objects[type].prototype.constructor = this.objects[type];
    });
}

AodObjectFactory.prototype = {
    get: function get(type, record) {
        return record instanceof this.objects[type]
            ? record
            : new this.objects[type](record, this.aodService);
    },
    getList: function getList(type, list)
    {
        return ( isArray(list) ? map : mapValues )(list, record =>{
            return this.get(type,record);
        });
    },
    hasObject: function hasObject(name){
        return name in this.objects;
    }
};